<template>
  <AbanSelect
    v-model:options="markets"
    label="symbol"
    field="symbol"
    :placeholder="'Market'"
    :use-not-wrapped-slot="true"
    :title="'Markets'"
    :do-search="true"
    :do-filter="true"
    :disabled="disabled"
    :no-space="noSpace"
    :select-size="100"
    :max-height="'30rem'"
    :filters="[
      { name: 'Market Type', field: 'type', type: 'marketType' }
    ]"
    :nullable="true"
    :listApiFunc="listMarkets"
  >
    <template v-for="(market, index) in markets" :key="index" v-slot:[`${market.symbol}`]>
      <MarketShortDisplay :no-space="noSpace" :market="market" />
    </template>
  </AbanSelect>
</template>

<script>
import AbanSelect from './Select.vue'
import MarketShortDisplay from '../../logic/market/MarketShortDetail.vue'
import { Market } from '../../logic/market/market'

export default {
  data() {
    return {
      markets: [],
      marketsModal: false
    }
  },
  components: {
    AbanSelect,
    MarketShortDisplay
  },
  props: {
    isAdmin: {
      default: false
    },
    disabled: {
      default: false
    },
    noSpace: {
      default: false
    }
  },
  methods: {
    listMarkets(page, pageSize, listOptions) {
      return this.isAdmin
        ? Market.listByAdmin(page, pageSize, listOptions)
        : Market.list(page, pageSize, listOptions)
    }
  }
}
</script>

<style>
</style>